export const EVENT_DICTIONARY = {
  view_exterior: 'verParteExterna',
  view_interior: 'verParteInterna',
  hide_hotspots: 'ocultarDestaques',
  view_hotspots: 'exibirDestaques',
}
